export default "__VITE_ASSET__oM_uOH8c__"